import i18n from 'i18next';
import { store } from '../Redux/store';
import { GetCategoryByStatus } from "./get-category-by-status";
import { 
  AddMonitoringOrdersList, 
  DecreaseStatsCategoryNumber, 
  DeleteCategoryOrdersList, 
  IncreaseStatsCategoryNumber, 
  RemoveMonitoringOrders, 
  UpdateCategoryOrdersList, 
  UpdateMonitoringOrdersList, 
  UpdateSearchOrdersList 
} from "../Redux/actions/actionNames";
import _ from "lodash";
import { getCategoryList } from "../components/main/order-list/components/category-collapse-list/action/getCategoryList";
import { UpdateOrdersStatistics } from "./update-ordersStatistics";
import momentJalaali from "moment-jalaali";

export const UpdateAddOrderBySocket = async (socketOrder) => {
  const storeData = store.getState();
  console.log("dispatcher:order:updated x2", socketOrder.id, momentJalaali().format("hh:mm:ss"));

  // حذف سفارش از دسته‌بندی‌ها
  await deleteOrderFromCategories(socketOrder, storeData);

  // مدیریت جستجو
  if (storeData.OrderList.search.regexText?.length > 2) {
    const index = storeData.OrderList.search.data.findIndex(order => order.id === socketOrder.id);
    if (index > -1) {
      store.dispatch(UpdateSearchOrdersList(socketOrder));
    }
    return;
  }

  // بررسی وضعیت سفارش
  if (await checkStatus(socketOrder, storeData)) {
    console.log("dispatcher:order:updated x3", socketOrder.id, momentJalaali().format("hh:mm:ss"));

    handleMonitoringOrders(socketOrder, storeData);
    const category = GetCategoryByStatus(socketOrder.status, socketOrder.isDispatching, socketOrder.type, socketOrder.driverAssignmentModel, socketOrder.isDelayed, socketOrder.isPossibleForDelay);
    const pinnedCategory = storeData.OrderList.list["Pinned"].data[socketOrder.id] ? "Pinned" : null;

    const categoryData = storeData.OrderList.list[category];
    const cursor = storeData.OrderList.cursor;

    if (categoryData.data[socketOrder.id] || pinnedCategory) {
      console.log("dispatcher:order:updated x4", socketOrder.id, momentJalaali().format("hh:mm:ss"));

      updateOrderInCategory(socketOrder, category, pinnedCategory);
    } else {
      console.log("dispatcher:order:updated x6", socketOrder.id, momentJalaali().format("hh:mm:ss"));

      if (_.isEmpty(categoryData.data)) {
        console.log("dispatcher:order:updated x7", socketOrder.id, momentJalaali().format("hh:mm:ss"));
        UpdateOrdersStatistics();
      } else {       
         UpdateOrdersStatistics();

        handleCategoryInsertion(socketOrder, category, categoryData, cursor);

      }
    }
  } else {
    if (await deleteOrderIfExists(socketOrder, storeData)) {
      console.log("dispatcher:order:updated x9", socketOrder.id, momentJalaali().format("hh:mm:ss"));
      UpdateOrdersStatistics();
    }
    UpdateOrdersStatistics();

    removeMonitoringOrder(socketOrder, storeData);
  }
};

const deleteOrderFromCategories = async (socketOrder, storeData) => {
  const currentCategory = GetCategoryByStatus(socketOrder.status, socketOrder.isDispatching, socketOrder.type, socketOrder.driverAssignmentModel, socketOrder.isDelayed, socketOrder.isPossibleForDelay);
  const otherCategories = ["Pending", "DispatchLater", "Dispatching", "Assigned", "InProgress", "Collecting", "Delivering", "Transit", "Canceled", "Done"]
    .filter(category => category !== currentCategory);

  for (const category of otherCategories) {
    const categoryData = storeData.OrderList.list[category]?.data || {};
    if (categoryData[socketOrder.id]) {
      store.dispatch(DeleteCategoryOrdersList({ key: category, data: socketOrder }));
    }
  }
};

const checkStatus = async (socketOrder, storeData) => {
  const selectedStatus = JSON.parse(storeData.OrderList.selectedStatus || "[]");
  return selectedStatus.length === 0 || selectedStatus.includes(socketOrder.status);
};

const deleteOrderIfExists = async (socketOrder, storeData) => {
  const categories = ["Pending", "Assigned", "InProgress", "Collecting", "Delivering", "Transit", "Canceled", "Done"];
  for (const category of categories) {
    if (storeData.OrderList.list[category]?.data[socketOrder.id]) {
      return true;
    }
  }
  return false;
};

const handleMonitoringOrders = (socketOrder, storeData) => {
  if (storeData.Monitoring.orders.open) {
    if (storeData.Monitoring.orders.data[socketOrder.id]) {
      store.dispatch(UpdateMonitoringOrdersList(socketOrder));
    } else {
      store.dispatch(UpdateMonitoringOrdersList(socketOrder));
    }
  }
};

const updateOrderInCategory = (socketOrder, category, pinnedCategory) => {
  store.dispatch(UpdateCategoryOrdersList({ key: category, data: socketOrder }));
  if (pinnedCategory) {
    store.dispatch(UpdateCategoryOrdersList({ key: pinnedCategory, data: socketOrder }));
  }
  UpdateOrdersStatistics();
};

const handleCategoryInsertion = (socketOrder, category, categoryData, cursor) => {
  const cursorSort = store.getState().OrderList.cursorSort;
  if ((cursorSort === "ascending" && socketOrder[cursor] < categoryData.endCursor) || 
      (cursorSort !== "ascending" && socketOrder[cursor] > categoryData.endCursor)) {
    store.dispatch(UpdateCategoryOrdersList({ key: category, data: socketOrder }));
  }
};

const removeMonitoringOrder = (socketOrder, storeData) => {
  if (storeData.Monitoring.orders.open && storeData.Monitoring.orders.data[socketOrder.id]) {
    console.log("dispatcher:order:updated x10", socketOrder.id, momentJalaali().format("hh:mm:ss"));
    store.dispatch(RemoveMonitoringOrders(socketOrder));
  }
};